import React, { useCallback, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { ID, l } from 'app/blocks/common/codes';
import { useAuth } from 'app/blocks/common/providers/AuthProvider';
import SvgIcon from 'app/blocks/common/svg-icon/svg-icon';
import { logout } from 'app/blocks/middleware/authentication';

import './index.scss';

type ImitationIndicatorComponentProps = {
    action: () => void;
    actionText: string;
    titleText: string;
};

const ImitationIndicatorComponent: React.FC<ImitationIndicatorComponentProps> = ({ action, actionText, titleText }) => {
    useEffect(() => {
        const bordersStyles = ['Left', 'Right', 'Bottom', 'Top'];
        const main = document.getElementById('as-main') || document.querySelector('body');
        const styledBorders = bordersStyles.map(className => {
            const border = document.createElement('div');
            border.classList.add('ImitationBorder', className);
            main.appendChild(border);
            return border;
        });
        main.classList.add('ImitationSession');

        return () => {
            styledBorders.forEach(border => main.removeChild(border));
            main.classList.remove('ImitationSession');
        };
    }, []);

    return (
        <div className="ImitationIndicatorContainer" data-seleniumid="imitation-indicator-container">
            <div className="ImitationIndicator container-lg">
                <div className="ImitationIndicator-Title">{actionText}</div>
                <button className="ImitationIndicator-Action" onClick={action} type="button">
                    <SvgIcon.stopArrow />
                    <div className="ImitationIndicator-Action-Title">{titleText}</div>
                </button>
            </div>
        </div>
    );
};

function ImitationIndicator() {
    const { user } = useAuth();

    const stopImitation = useCallback(() => {
        logout(false);
    }, []);

    if (user?.loggedIn && user?.isAdminMode) {
        return (
            <ImitationIndicatorComponent
                action={stopImitation}
                actionText={l(`${ID.BUTTONS}.IMITATION.TITLE`)}
                titleText={l(`${ID.BUTTONS}.IMITATION.ACTION`)}
            />
        );
    }
    return null;
}

function renderImitationIndicator() {
    return ReactDOM.createPortal(<ImitationIndicator />, document.getElementById('AS__imitation'));
}

export { ImitationIndicatorComponent, renderImitationIndicator };
export default ImitationIndicator;
